import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppData } from '../AppContext';
import { DEF_CONTACT_CTA } from '../store';
import './ContactCTA.css';

const ContactCTA = () => {
  const { contactCTA } = useAppData();
  const d = contactCTA || DEF_CONTACT_CTA;
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email.trim()) { setSubscribed(true); setEmail(''); }
  };

  return (
    <>
      <section className="newsletter-section">
        <div className="newsletter-inner" data-aos="fade-up">
          <div className="newsletter-icon">
            <svg viewBox="0 0 70 60" width="68" height="58" fill="none">
              <rect x="4" y="12" width="62" height="42" rx="4" fill="#a8c8e8" stroke="#7aaed4" strokeWidth="1.5" />
              <polyline points="4,12 35,36 66,12" fill="none" stroke="#2878c4" strokeWidth="2.5" />
              <rect x="20" y="2" width="30" height="22" rx="2" fill="#f0f8ff" stroke="#7aaed4" strokeWidth="1.5" />
              <line x1="26" y1="10" x2="44" y2="10" stroke="#b0c8e0" strokeWidth="1.5" />
              <line x1="26" y1="16" x2="40" y2="16" stroke="#b0c8e0" strokeWidth="1.5" />
            </svg>
          </div>
          <h2 className="newsletter-heading">{d.newsletter.heading}</h2>
          {subscribed ? (
            <p className="newsletter-success">{d.newsletter.successMsg}</p>
          ) : (
            <form className="newsletter-form" onSubmit={handleSubscribe}>
              <input type="email" className="newsletter-input" placeholder={d.newsletter.placeholder}
                value={email} onChange={e => setEmail(e.target.value)} required />
              <button type="submit" className="newsletter-btn">{d.newsletter.btnText}</button>
            </form>
          )}
        </div>
      </section>

      <section className="final-cta-section">
        <div className="final-cta-inner">
          <div className="final-cta-text" data-aos="fade-right">
            <h2>{d.cta.heading}</h2>
            <Link to={d.cta.btnLink || '/products'} className="btn-shop-now">{d.cta.btnText}</Link>
          </div>
          <div className="final-cta-visual">
            <img src={d.cta.image} alt="Zinga Products" />
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactCTA;
